import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TopupcardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchTopupcardPlans } from "../../../../features/auth/store/topupcardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import TopupCard from "./Topupcard";

const ElectricRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedTopupPlan, setSelectedTopupPlan] = useState<Product | null>(
    null
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { topupcardPlans, loading, error } = useSelector(
    (state: RootState) => state.topupcardPlans
  );

  useEffect(() => {
    const filters: any = {};

    // Only add status filter if it's not empty
    if (statusFilter && statusFilter !== "") {
      filters.status = statusFilter;
    }
    if (searchTerm && searchTerm !== "") {
      filters.search = searchTerm;
    }

    dispatch(fetchTopupcardPlans(filters));
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleTopupPlanClick = (dataPlan: Product) => {
    setSelectedTopupPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedTopupPlan(null);
  };

  if (showDetailView && selectedTopupPlan) {
    return (
      <TopupcardDetailView
        topupPlan={{
          ...selectedTopupPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <TopupCard
      topupcardPlans={topupcardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onTopupPlanClick={handleTopupPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default ElectricRouter;
